var Backbone = require('backbone');
var template = require('../templates/error.ejs');

'use strict';

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-error',
    events: {
        'click .vote': 'home'
    },
    /**
   *
   */
    initialize: function(options) {
        this.model = options.model;
        this.router = options.router;
    },
    /**
   *
   */
    render: function() {
        this.$el.html(template(this.model));
        return this;
    },
    /**
   *
   */
    home: function() {
        this.router.closeCurrentModal();
    },
  
    remove: function() {
        this.off();
        Backbone.View.prototype.remove.call(this);
    }

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/error.js
// module id = 211
// module chunks = 0